module.exports = __webpack_public_path__ + "img/cac796f606579781436de091166cd3d1.png";